import * as types from "../types/single-list";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  retrieveListDetails,
  retrieveListResponses,
  retrieveCompanyDetails,
  retrieveCompanyNotes,
  deleteListCompanyNote,
  addListCompanyNote,
  retrieveClientStatus,
  addNewClient,
  removeExistingClient,
  addNewResponse,
  retrieveCompanyDeletions,
  removeCompanyListing,
  retrieveContactListSelections,
  addCompanyContactList,
} from "../../networking/single-list/networking";

function* fetchSingleList(action) {
  try {
    const list = yield call(retrieveListDetails, action.payload);
    if (list.error === null && list.payload) {
      yield put({ type: types.SET_SINGLE_LIST_DETAILS, list: list.payload });
    } else {
      throw new Error("Kunne ikke hente listedetaljer.");
    }
  } catch (e) {
    yield put({
      type: types.REVOKE_SINGLE_LIST_DETAILS,
      message: "Kunne ikke hente liste.",
    });
  }
}

function* fetchListResponses(action) {
  try {
    const responses = yield call(retrieveListResponses, action.payload);
    if (responses.error === null && responses.payload) {
      yield put({
        type: types.SET_SINGLE_LIST_RESPONSES,
        responses: responses.payload,
      });
    } else {
      throw new Error(responses);
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_LIST_RESPONSE, message: e });
  }
}

function* fetchCompanyDetails(action) {
  try {
    const details = yield call(retrieveCompanyDetails, action.details);
    if (details.error === null) {
      yield put({
        type: types.GRANT_SET_ACTIVE_COMPANY_DETAILS,
        details: details.payload,
      });
    } else {
      throw new Error(details.error);
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SET_ACTIVE_COMPANY_DETAILS });
  }
}

function* fetchCompanyNotes(action) {
  try {
    const notes = yield call(retrieveCompanyNotes, action.details);
    if (notes !== "error") {
      yield put({
        type: types.GRANT_SET_ACTIVE_COMPANY_NOTES,
        notes: notes.payload,
      });
    } else {
      throw new Error(notes);
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SET_ACTIVE_COMPANY_NOTES, message: e });
  }
}

function* fetchCompanyClientStatus(action) {
  try {
    if (action.details) {
      var status = yield call(retrieveClientStatus, action.details);
      if (status.error === null) {
        yield put({
          type: types.SET_LIST_COMPANY_STATUS,
          status: status.payload,
        });
      } else {
        throw new Error("Kunne ikke hente kundestatus.");
      }
    } else {
      throw new Error("Kunne ikke hente kundestatus.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_LIST_COMPANY_STATUS, message: e });
  }
}

function* performAddListCompanyNote(action) {
  try {
    if (action.details) {
      var response = yield call(addListCompanyNote, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_LIST_COMPANY_NOTE });
      } else {
        throw new Error("Kunne ikke legge til notat.");
      }
    } else {
      throw new Error("Kunne ikke legge til notat.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_LIST_COMPANY_NOTE, message: e });
  }
}

function* performDeleteListNote(action) {
  try {
    if (action.details) {
      var response = yield call(deleteListCompanyNote, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_LIST_COMPANY_NOTE });
      } else {
        throw new Error("Kunne ikke slette notat.");
      }
    } else {
      throw new Error("Kunne ikke slettet notat.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_LIST_COMPANY_NOTE, message: e });
  }
}

function* performAddNewClient(action) {
  try {
    if (action.details) {
      var response = yield call(addNewClient, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_CREATE_NEW_CLIENT });
      } else {
        throw new Error("Kunne ikke legge til kunde.");
      }
    } else {
      throw new Error("Kunne ikke legge til kunde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CREATE_NEW_CLIENT, message: e });
  }
}

function* performRemoveExistingClient(action) {
  try {
    if (action.details) {
      var response = yield call(removeExistingClient, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_EXISTING_CLIENT });
      } else {
        throw new Error("Kunne ikke fjerne kunde.");
      }
    } else {
      throw new Error("Kunne ikke fjerne kunde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_EXISTING_CLIENT, message: e });
  }
}

function* performAddListCompanyResponse(action) {
  try {
    if (action.details) {
      var response = yield call(addNewResponse, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_LIST_COMPANY_RESPONSE });
      } else {
        throw new Error("Kunne ikke legge til respons.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_LIST_COMPANY_RESPONSE, message: e });
  }
}

function* fetchListDeletions(action) {
  try {
    if (action.details) {
      var response = yield call(retrieveCompanyDeletions, action.details);
      if (response.error === null && response.payload) {
        yield put({
          type: types.SET_COMPANY_DELETIONS,
          list: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente slettinger.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_COMPANY_DELETIONS, message: e });
  }
}

function* performCompanyDeletion(action) {
  try {
    if (action.details) {
      var response = yield call(removeCompanyListing, action.details);
      if (response.error === null) {
        yield put({
          type: types.GRANT_REMOVE_COMPANY_LISTING,
          organizationNumber: response.payload,
        });
      } else {
        throw new Error("Kunne ikke slette virksomhet.");
      }
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_COMPANY_LISTING, message: e });
  }
}

function* fetchCompanyContactLists(action) {
  try {
    const response = yield call(retrieveContactListSelections, action.details);
    if (response.error === null) {
      yield put({
        type: types.GRANT_FETCH_CONTACT_LISTS,
        data: response.payload,
      });
    } else {
      throw new Error("Kunne ikke hente kontaktlister.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_FETCH_CONTACT_LISTS, message: e });
  }
}

function* performAddCompanyContact(action) {
  try {
    if (action.details) {
      var response = yield call(addCompanyContactList, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_CREATE_NEW_CONTACT });
        yield put({
          type: types.CHANGE_SINGLE_LIST_MODALS,
          modal: { addContactModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til kontakt.");
      }
    } else {
      throw new Error("Kunne ikke legge til kontakt.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CREATE_NEW_CONTACT, message: e });
    yield put({
      type: types.CHANGE_SINGLE_LIST_MODALS,
      modal: { addContactModal: false },
    });
  }
}

function* singleListSaga() {
  yield all([
    takeEvery(types.REQUEST_SINGLE_LIST_DETAILS, fetchSingleList),
    takeEvery(types.REQUEST_SINGLE_LIST_RESPONSES, fetchListResponses),
    takeEvery(types.REQUEST_SET_ACTIVE_COMPANY_DETAILS, fetchCompanyDetails),
    takeEvery(types.REQUEST_SET_ACTIVE_COMPANY_NOTES, fetchCompanyNotes),
    takeEvery(types.REQUEST_REMOVE_LIST_COMPANY_NOTE, performDeleteListNote),
    takeEvery(types.REQUEST_ADD_LIST_COMPANY_NOTE, performAddListCompanyNote),
    takeEvery(types.REQUEST_LIST_COMPANY_STATUS, fetchCompanyClientStatus),
    takeEvery(types.REQUEST_CREATE_NEW_CLIENT, performAddNewClient),
    takeEvery(
      types.REQUEST_REMOVE_EXISTING_CLIENT,
      performRemoveExistingClient
    ),
    takeEvery(
      types.REQUEST_ADD_LIST_COMPANY_RESPONSE,
      performAddListCompanyResponse
    ),
    takeEvery(types.REQUEST_COMPANY_DELETIONS, fetchListDeletions),
    takeEvery(types.REQUEST_REMOVE_COMPANY_LISTING, performCompanyDeletion),
    takeEvery(types.REQUEST_FETCH_CONTACT_LISTS, fetchCompanyContactLists),
    takeEvery(types.REQUEST_CREATE_NEW_CONTACT, performAddCompanyContact),
  ]);
}

export default singleListSaga;
